import React from "react";
import { Button } from "reactstrap";
import { deleteWorkflow, fetchMappingByRecruiterId } from "./Axios";

const WorkflowHit = ({ index, workflow, reloadWorkflows, showNotification, onSelect, onMap }) => {
  const handleDelete = async () => {
    if (!workflow.locked && window.confirm("¿Seguro que deseas eliminar este workflow?")) {
      try {
        await deleteWorkflow(workflow.id);
        showNotification("Éxito", "Workflow eliminado correctamente", "success");
        reloadWorkflows();
      } catch {
        showNotification("Error", "No se pudo eliminar el workflow", "danger");
      }
    }
  };

  const handleOpenMapping = async () => {
    try {
      const mapping = await fetchMappingByRecruiterId(workflow.id);
      if (mapping) onMap(mapping);
    } catch {}
  };

  return (
    <tr>
      <td>{index}</td>
      <td>{workflow.name}</td>
      <td>{workflow.is_candidate_workflow ? "Candidato" : "Reclutador"}</td>
      <td className="text-end">
        <Button color="info" size="sm" onClick={onSelect} className="mr-2">
          {workflow.locked ? "Ver" : "Editar"}
        </Button>

        {!workflow.is_candidate_workflow && (
          <>
            <Button color="warning" size="sm" onClick={handleOpenMapping} className="ms-2">
              {workflow.locked ? "Ver Mapeo" : "Configurar Mapeo"}
            </Button>
            {!workflow.locked && (
              <Button color="danger" size="sm" onClick={handleDelete} className="ms-2">
                Eliminar
              </Button>
            )}
          </>
        )}
      </td>
    </tr>
  );
};

export default WorkflowHit;
